// TODO REPLACE THIS STOR TO MOBX
export default new (class Store {
  inviteCode;
  name;
  siteName;
})();
